/* global __APP__ */

import $ from 'jquery';

let _localStorage = require('store');

export const jwt = () => _localStorage.get('jwtToken');

const addHeaders = {
  beforeSend(req) {
    req.setRequestHeader('Authorization', 'Bearer ' + jwt());
    req.setRequestHeader('user-ip', __APP__ . IP );
    req.setRequestHeader('user-country', __APP__ . country_2 );
  }
};

const userDetailsHeaders = {
  beforeSend(req) {
    req.setRequestHeader('user-ip', __APP__ . IP );
    req.setRequestHeader('user-country', __APP__ . country_2 );
  }
};

export const registerPlayer = userData =>
  $.ajax({
    method: 'POST',
    dataType: 'json',
    url: `/platform-api/player/registerPlayer`,
    data: userData
  });

export const activatePlayer = (token) =>
  $.ajax({
    method: 'POST',
    dataType: 'json',
    url: `/platform-api/player/activate`,
    data: {
      token,
    },
    ...userDetailsHeaders
  });

export const login = (login, password, platform, device) =>
  $.ajax({
    method: 'POST',
    dataType: 'json',
    url: `/platform-api/auth/login`,
    data: { login, password, platform, device},
    ...userDetailsHeaders
  });

export const refreshToken = () =>
  $.ajax({
    method: 'GET',
    dataType: 'json',
    url: `/platform-api/player/refreshToken`,
    ...addHeaders,
  });

export const logout = () =>
  $.ajax({
    method: 'POST',
    dataType: 'json',
    url: `/platform-api/auth/logout`,
    ...addHeaders,
  });

export const getPlayer = () =>
  $.ajax({
    method: 'GET',
    dataType: 'json',
    url: `/platform-api/player/details`,
    ...addHeaders,
  });

export const getKYCStatus = () =>
  $.ajax({
    method: 'GET',
    dataType: 'json',
    url: `/platform-api/player/getKYCStatus`,
    ...addHeaders,
  });

export const updateUserInfo = userData =>
  $.ajax({
    method: 'POST',
    dataType: 'json',
    url: `/platform-api/player/update/details`,
    data: userData,
    ...addHeaders,
  });

export const privacyRequest = (type, body) =>
  $.ajax({
    method: 'POST',
    dataType: 'json',
    url: `/platform-api/player/privacyRequest`,
    data: {
      type,
      body,
    },
    ...addHeaders,
  });

export const acceptTC = () =>
  $.ajax({
    method: 'POST',
    dataType: 'json',
    url: `/platform-api/player/acceptTC`,
    ...addHeaders,
  });

export const updateUserPassword = (oldPassword, newPassword, newPasswordConfirm) =>
  $.ajax({
    method: 'POST',
    dataType: 'json',
    url: `/platform-api/player/update/password`,
    data: {
      oldPassword,
      newPassword,
      newPasswordConfirm,
    },
    ...addHeaders,
  });

export const forgotStep1 = (username, email, birthDate, activateUrl) =>
  $.ajax({
    method: 'POST',
    dataType: 'json',
    url: `/platform-api/player/forgot/step1`,
    data: {
		username,
		email,
		birthDate,
		activateUrl,
	},
    ...addHeaders,
  });

export const forgotStep2 = (token) =>
  $.ajax({
    method: 'POST',
    dataType: 'json',
    url: `/platform-api/player/forgot/step2`,
    data: {
		token,
	},
    ...addHeaders,
  });

export const forgotStep3 = (newPassword, newPasswordConfirm) =>
  $.ajax({
    method: 'POST',
    dataType: 'json',
    url: `/platform-api/player/forgot/step3`,
    data: {
		newPassword,
		newPasswordConfirm,
	},
    ...addHeaders,
  });

export const makeDeposit = (userName, amount, dateTime, obstractCode) =>
  $.ajax({
    method: 'POST',
    dataType: 'json',
    url: `bank_deposit_result`,
    data: {
      userName,
      amount,
      dateTime,
      obstractCode,
    },
    ...addHeaders,
  });

export const makeWithdrawal = (userName, bankCardNumber, amount, fullName) =>
  $.ajax({
    method: 'POST',
    dataType: 'json',
    url: `bank_withdrawal_result`,
    data: {
      userName,
      bankCardNumber,
      amount,
      fullName,
    },
    ...addHeaders,
  });

export const updateUserLanguage = language =>
  $.ajax({
    method: 'POST',
    dataType: 'json',
    url: `/platform-api/player/update/language`,
    data: {
      language,
    },
    ...addHeaders,
  });

export const getGame = (id, live = true) =>
  $.ajax({
     method: 'GET',
     dataType: 'json',
     url: `/platform-api/game/${live ? 'live' : 'demo'}/${id}`,
    ...addHeaders,
   });

export const getGameTransactions = (page, startDate, endDate) =>
  $.ajax({
    method: 'GET',
    dataType: 'json',
    url: `/platform-api/transactions/casino/${page}`,
    data: {
      startDate,
      endDate,
    },
    ...addHeaders,
  });

export const getDepositTransactions = (page, startDate, endDate) =>
  $.ajax({
    method: 'GET',
    dataType: 'json',
    url: `/platform-api/transactions/deposits/${page}`,
    data: {
      startDate,
      endDate,
    },
    ...addHeaders,
  });

export const getDepositMethods = (provider, userIP = null) =>
  $.ajax({
    method: 'POST',
    dataType: 'json',
    url: `/platform-api/deposit/getMethods`,
    data: {
		provider,
    userIP
    },
    ...addHeaders,
  });

export const depositInit = (amount, provider, method, bonusId = null, bonusCategory = null, successUrl, failureUrl, extra = {}) =>
  $.ajax({
    method: 'POST',
    dataType: 'json',
    url: `/platform-api/deposit/init`,
    data: {
		amount,
    provider,
		method,
		bonusId,
		bonusCategory,
		successUrl,
    failureUrl,
    extra,
    },
    ...addHeaders,
  });

export const depositNotify = (provider, method, params) =>
  $.ajax({
    method: 'POST',
    dataType: 'json',
    url: `/platform-api/deposit/notify`,
    data: {
      provider,
      method,
      params
    },
    ...addHeaders,
  });

export const depositUserAccount = (accountNumber, provider, bank, bankCode) =>
  $.ajax({
    method: 'GET',
    dataType: 'json',
    url: `/platform-api/deposit/user-account?provider=${provider}`,
    data: {
      accountNumber,
      bank,
      bankCode
    },
    ...addHeaders,
  });

export const getWithdrawalMethods = (provider, userIP = null) =>
  $.ajax({
    method: 'POST',
    dataType: 'json',
    url: `/platform-api/withdrawal/getMethods`,
    data: {
		provider,
    userIP
    },
    ...addHeaders,
  });

export const withdrawalInit = (amount, method, accountNumber = null, bankCode = null, doCancelBonus = 0) =>
  $.ajax({
    method: 'POST',
    dataType: 'json',
    url: `/platform-api/withdrawal/init`,
    data: {
      amount,
      method,
      accountNumber,
      bankCode,
      doCancelBonus
    },
    ...addHeaders,
  });

export const getAvailableBanks = () =>
  $.ajax({
    method: 'GET',
    dataType: 'json',
    url: `/platform-api/withdrawal/getAvailableBanks`,
    ...addHeaders,
  });

export const getListBanks = (provider, country) =>
  $.ajax({
    method: 'GET',
    dataType: 'json',
    url: `/platform-api-v2/user/withdrawal/list-banks?provider=${provider}&country=${country}`,
    ...addHeaders,
  });

export const saveBankAccount = (bank_code, account_number) =>
  $.ajax({
    method: 'POST',
    dataType: 'json',
    url: `/platform-api-v2/user/bank-account/save-bank-account`,
    data: {
      bank_code,
      account_number
    },
    ...addHeaders,
  });

export const getBankAccount = () =>
  $.ajax({
    method: 'GET',
    dataType: 'json',
    url: `/platform-api-v2/user/bank-account/get-bank-account`,
    ...addHeaders,
  });


export const getWithdrawTransactions = (page, startDate, endDate) =>
  $.ajax({
    method: 'GET',
    dataType: 'json',
    url: `/platform-api-v2/user/withdrawal/list`,
    data: {
      startDate,
      endDate,
      page
    },
    ...addHeaders,
  });

export const getSportsBook = (live = false) =>
  $.ajax({
    method: 'GET',
    dataType: 'json',
    url: `/platform-api/sportsbook/${live ? 'live' : 'demo'}`,
    ...addHeaders,
  });

export const getGoldenRace = (userId) =>
  $.ajax({
    method: 'GET',
    dataType: 'json',
    url: `/platform-api-v2/golden-race/get-online-hash`,
    data: {
      userId
    },
    ...addHeaders,
  });

export const getGoldenRaceDemo = () =>
  $.ajax({
    method: 'GET',
    dataType: 'json',
    url: `/platform-api-v2/golden-race/get-demo`,
  });

export const getAvailableBonuses = (category = null) =>
  $.ajax({
    method: 'GET',
    dataType: 'json',
    url: `/platform-api/bonus/getAvailableBonuses${category != null ? '?category=' + category : ''}`,
    ...addHeaders,
  });

export const getActiveBonus = () =>
  $.ajax({
    method: 'GET',
    dataType: 'json',
    url: `/platform-api/bonus/getActiveBonus`,
    ...addHeaders,
  });

  export const getActiveCasinoBonus = () =>
  $.ajax({
    method: 'GET',
    dataType: 'json',
    url: `/platform-api-v2/bonus/get-active-casino-bonus`,
    ...addHeaders,
  });  

export const getBonusHistory = (page) =>
  $.ajax({
    method: 'GET',
    dataType: 'json',
    url: `/platform-api/bonus/getBonusHistory?page=${page}`,
    ...addHeaders,
  });

/* -----------------------------------------
 ggpoker API
 ----------------------------------------- */
export const walletTransfer = (amount, direction) =>
  $.ajax({
    method: 'POST',
    dataType: 'json',
    url: `/platform-api/ggpoker/transfer`,
    data: {
      amount,
      direction
    },
    ...addHeaders,
  });

export const walletBalance = () =>
$.ajax({
  method: 'GET',
  dataType: 'json',
  url: `/platform-api/ggpoker/balance?forceReload=true`,
  ...addHeaders,
});
/* -----------------------------------------
 DiDi API
 ----------------------------------------- */
export const fetchGames = (country, category) =>
  $.ajax({
    url: `${__APP__.didiApiUrl}/games`,
    method: 'GET',
    dataType: 'json',
    data: {
      lang: __APP__.langShort,
      category_id: category,
      country: country
    },
  });

export const fetchAllGamesNames = () =>
  $.ajax({
    url: `${__APP__.didiApiUrl}/all-games-names`,
    method: 'GET',
    dataType: 'json',
    data: {
      lang: __APP__.langShort,
    },
  });  

export const fetchCurrencies = () =>
  $.ajax({
    url: `${__APP__.didiApiUrl}/get-currencies`,
    method: 'GET',
    dataType: 'json',
    data: {
     lang: __APP__.langShort,
    },
 });  

export const fetchGame = (game, country) =>
  $.ajax({
    url: `${__APP__.didiApiUrl}/game`,
    method: 'GET',
    dataType: 'json',
    data: {
      lang: __APP__.langShort,
      country: country,
      game_id: game
    },
  });

export const fetchGameCategories = () =>
  $.ajax({
    url: `${__APP__.didiApiUrl}/game-categories`,
    method: 'GET',
    dataType: 'json',
    data: {
      lang: __APP__.langShort,
    },
  });

export const fetchGameProviders = (casinoType, country) =>
  $.ajax({
    url: `${__APP__.didiApiUrl}/game-providers`,
    method: 'GET',
    dataType: 'json',
    data: {
      lang: __APP__.langShort,
      type_id: (typeof(casinoType) !== undefined)?casinoType:'',
      country,
    },
  });

  export const modalPage = page =>
  $.ajax({
    method: 'GET',
    dataType: 'json',
    url: `${__APP__.didiApiUrl}/page`,
    data: {
      page,
      lang: __APP__.langShort,
    },
  });

/* -----------------------------------------
AGENT-LUDOCO API
----------------------------------------- */

export const changePassword = (agentId, userId, newPassword) =>
  $.ajax({
    method: 'POST',
    dataType: 'json',
    url: `/agent-api/changePassword`,
    data: {
      agentId,
      userId,
      newPassword,

    },
  });

export const changeBalance = (agentId, amount, transactionId, referenced_id, userId) =>
  $.ajax({
    method: 'POST',
    dataType: 'json',
    url: `/agent-api/changeBalance`,
    data: {
      userId,
      agentId,
      amount,
      transactionId,
      referenced_id,
    },
  });

export const financialReport = (agentId, dateFrom, dateTo) =>
  $.ajax({
    method: 'POST',
    dataType: 'json',
    url: `/agent-api/report/financial`,
    data: {
      agentId,
      dateFrom,
      dateTo,
    },
    ...addHeaders,
  });

export const casinoReport = (agentId, dateFrom, dateTo) =>
  $.ajax({
    method: 'POST',
    dataType: 'json',
    url: `/agent-api/report/casino`,
    data: {
      "agentId": agentId,
      "dateFrom": dateFrom,
      "dateTo": dateTo,
    },
    ...addHeaders,
  });

export const bettingReport = (agentId, dateFrom, dateTo, betFilter) =>
  $.ajax({
    method: 'POST',
    dataType: 'json',
    url: `/agent-api/report/betting`,
    data: {
      agentId,
      dateFrom,
      dateTo,
      betFilter,
    },
  });

export const goldenRaceReport = (agentId, dateFrom, dateTo, betFilter) =>
  $.ajax({
    method: 'POST',
    dataType: 'json',
    url: `/agent-api/report/golden-race`,
    data: {
      agentId,
      dateFrom,
      dateTo,
      betFilter,
    },
  });

export const pokerReport = (agentId, dateFrom, dateTo) =>
  $.ajax({
    method: 'POST',
    dataType: 'json',
    url: `/agent-api/report/poker`,
    data: {
      agentId,
      dateFrom,
      dateTo,
    },
  });

export const casinoTransactions = (userId, dateFrom, dateTo) =>
  $.ajax({
    method: 'POST',
    dataType: 'json',
    url: `/agent-api/transactions/casino`,
    data: {
      userId,
      dateFrom,
      dateTo,
    },
  });

export const financialTransactions = (userId, dateFrom, dateTo) =>
  $.ajax({
    method: 'POST',
    dataType: 'json',
    url: `/agent-api/transactions/financial`,
    data: {
      userId,
      dateFrom,
      dateTo,
    },
    ...addHeaders,
  });

export const bettingTransactions = (userId, dateFrom, dateTo) =>
  $.ajax({
    method: 'POST',
    dataType: 'json',
    url: `/agent-api/transactions/betting`,
    data: {
      userId,
      dateFrom,
      dateTo,
    },
  });

export const goldenRaceTransactions = (userId, dateFrom, dateTo) =>
  $.ajax({
    method: 'POST',
    dataType: 'json',
    url: `/agent-api/transactions/golden-race`,
    data: {
      userId,
      dateFrom,
      dateTo,
    },
  });

export const pokerTransactions = (userId, dateFrom, dateTo) =>
  $.ajax({
    method: 'POST',
    dataType: 'json',
    url: `/agent-api/transactions/poker`,
    data: {
      userId,
      dateFrom,
      dateTo,
    },
  });

export const sportsBetDetails = (userId, betId) =>
  $.ajax({
    method: 'POST',
    dataType: 'json',
    url: `/agent-api/details/sports-bet`,
    data: {
      userId,
      betId,
    },
  });

export const isGoldenRaceAvailable = (external_id) =>
  $.ajax({
    method: 'GET',
    dataType: 'json',
    url: `/agent-api/golden-race/is-available/${external_id}`,
  });

export const getGoldenRaceLaunchPage = (staffId, agentId, pin) =>
  $.ajax({
    method: 'POST',
    dataType: 'json',
    url: `/agent-api/golden-race/get-launch-page`,
    data: {
      staffId,
      agentId,
      pin,
    },
  });

export const ElbetWalletTransfer = (direction, amount) =>
  $.ajax({
    method: 'POST',
    dataType: 'json',
    url: `/agent-api/elbet/wallet/transfer`,
    data: {
      direction,
      amount
    },
    ...addHeaders
  });

export const ElbetWallet = () =>
  $.ajax({
    method: 'GET',
    dataType: 'json',
    url: `/agent-api/elbet/wallet`,
    ...addHeaders
  });

/* -----------------------------------------
Front API v2
----------------------------------------- */

export const depositPaymentSupport = (service, currency) =>
  $.ajax({
    method: 'POST',
    dataType: 'json',
    data: {
      service,
      currency
    },
    url: `/platform-api/currency/is-supports`,
    ...addHeaders
});

export const getFiatCurrencyLimits = (fromCurrency, toCurrency, service, type) =>
  $.ajax({
    method: 'POST',
    dataType: 'json',
    data: {
      fromCurrency,
      toCurrency,
      service,
      type
    },
    url: `/platform-api/currency/calculate-limits`,
    ...addHeaders
  });

export const saveFinancialTransactionsAsCsv = (userId, dateFrom, dateTo) =>
  $.ajax({
    method: 'GET',
    dataType: 'json',
    url: `/platform-api-v2/report/transaction/financial-csv?dateFrom=${dateFrom}&dateTo=${dateTo}&userId=${userId}`,
    ...addHeaders,
  });

export const generateNewCasinoReport = (dateFrom, dateTo, agentId, pageSize='', page=0) =>
  $.ajax({
    method: 'GET',
    dataType: 'json',
    url: `/platform-api-v2/report/casino?dateFrom=${dateFrom}&dateTo=${dateTo}&userId=${agentId}&per-page=${pageSize}&page=${page}`,
    ...addHeaders
  });

export const saveCasinoReportAsCsv = (dateFrom, dateTo, agentId, pageSize='', page=0) =>
  $.ajax({
    method: 'GET',
    dataType: 'json',
    url: `/platform-api-v2/report/casino/csv?dateFrom=${dateFrom}&dateTo=${dateTo}&userId=${agentId}&per-page=${pageSize}&page=${page}`,
    ...addHeaders
  });

export const generateCasinoReportPerProvider = (dateFrom, dateTo, agentId) =>
  $.ajax({
    method: 'GET',
    dataType: 'json',
    url: `/platform-api-v2/report/casino/detail?dateFrom=${dateFrom}&dateTo=${dateTo}&userId=${agentId}`,
    ...addHeaders
  });

export const registerUser = (username, password, email, country, currency, name, surname, birthday, phone, activateUrl) =>
  $.ajax({
    method: 'POST',
    dataType: 'json',
    url: `/platform-api-v2/user/create-user`,
    data: {
      username,
      password,
      email,
      country,
      currency,
      name,
      surname,
      birthday,
      phone,
      activateUrl
    },
    ...addHeaders,
  });

export const registerCashier = (username, password, email, country, currency, name, surname, birthday, activateUrl) =>
  $.ajax({
    method: 'POST',
    dataType: 'json',
    url: `/platform-api-v2/user/create-cashier`,
    data: {
      username,
      password,
      email,
      country,
      currency,
      name,
      surname,
      birthday,
      activateUrl
    },
    ...addHeaders,
  });

export const registerAgent = (username, password, email, country, currency, name, surname, birthday, phone, activateUrl) =>
  $.ajax({
    method: 'POST',
    dataType: 'json',
    url: `/platform-api-v2/user/create-agent`,
    data: {
      username,
      password,
      email,
      country,
      currency,
      name,
      surname,
      birthday,
      phone,
      activateUrl
    },
    ...addHeaders,
  });

export const registerSuperAgent = (username, password, email, country, currency, name, surname, birthday, phone, activateUrl) =>
  $.ajax({
    method: 'POST',
    dataType: 'json',
    url: `/platform-api-v2/user/create-super-agent`,
    data: {
      username,
      password,
      email,
      country,
      currency,
      name,
      surname,
      birthday,
      phone,
      activateUrl
    },
    ...addHeaders,
  });

export const getAvailableCurrencies = () =>
  $.ajax({
    method: 'GET',
    dataType: 'json',
    url: `/platform-api-v2/currency/get-available`,
    ...addHeaders,
  });

export const getAgentHierarchyFullTotalBalance = () =>
  $.ajax({
    method: 'GET',
    dataType: 'json',
    url: `/platform-api-v2/balance/get-for-hierarchy`,
    ...addHeaders,
  });

export const getAgentHierarchyFull = () =>
  $.ajax({
    method: 'GET',
    dataType: 'json',
    url: `/platform-api-v2/cps/hierarchy/get-full`,
    ...addHeaders,
  });

export const getAgentDirectChildren = (userId) =>
  $.ajax({
    method: 'GET',
    dataType: 'json',
    url: `/platform-api-v2/hierarchy/get-direct-children`,
    data: {
      userId
    },
    ...addHeaders,
  });

export const getAgentHierarchyChildren = () =>
  $.ajax({
    method: 'GET',
    dataType: 'json',
    url: `/platform-api-v2/cps/hierarchy/get-children`,
    ...addHeaders,
  });

export const getAgentHierarchyParent = () =>
  $.ajax({
    method: 'GET',
    dataType: 'json',
    url: `/platform-api-v2/cps/hierarchy/get-parent`,
    ...addHeaders,
  });

export const getAgentWithdrawalList = () =>
  $.ajax({
    method: 'GET',
    dataType: 'json',
    url: `/platform-api-v2/cashier/withdrawal/list`,
    ...addHeaders,
  });

export const agentPayoutWithdrawal = (withdrawalId, withdrawalCode) =>
  $.ajax({
    method: 'POST',
    dataType: 'json',
    url: `/platform-api-v2/cashier/withdrawal/pay`,
    data: {
      withdrawalId,
      withdrawalCode,
    },
    ...addHeaders,
  });

export const agentCancelWithdrawal = (withdrawalId, withdrawalCode) =>
  $.ajax({
    method: 'POST',
    dataType: 'json',
    url: `/platform-api-v2/cashier/withdrawal/cancel`,
    data: {
      withdrawalId,
      withdrawalCode,
    },
    ...addHeaders,
  });

export const userCancelWithdrawal = (withdrawalId) =>
  $.ajax({
    method: 'POST',
    dataType: 'json',
    url: `/platform-api-v2/user/withdrawal/cancel?withdrawalId=${withdrawalId}`,
    ...addHeaders,
  });

export const agentDepositMoney = (userId, amount, note) =>
  $.ajax({
    method: 'POST',
    dataType: 'json',
    url: `/platform-api-v2/cashier/wallet/deposit`,
    data: {
      userId,
      amount,
      note,
    },
    ...addHeaders,
  });

export const searchUser = (searchUserText) =>
  $.ajax({
    method: 'GET',
    dataType: 'json',
    url: `/platform-api-v2/user/details-by-username?username=${searchUserText}`,
    ...addHeaders,
  });

export const getBalance = () =>
  $.ajax({
    method: 'GET',
    dataType: 'json',
    url: `/platform-api/player/balance`,
    ...addHeaders,
  });

export const getBalanceAgent = (userId) =>
  $.ajax({
    method: 'GET',
    dataType: 'json',
    url: `/platform-api-v2/balance?userId=${userId}`,
    ...addHeaders,
  });

export const searchBet = (userId, createdFrom, createdTo) =>
  $.ajax({
    method: 'GET',
    dataType: 'json',
    url: `/platform-api-v2/bet/search`,
    data: {
      userId,
      createdFrom,
      createdTo,
    },
    ...addHeaders,
  });

export const getBetDetail = (betId) =>
  $.ajax({
    method: 'GET',
    dataType: 'json',
    url: `/platform-api-v2/bet/get?betId=${betId}`,
    ...addHeaders,
  });

export const betPayout = (betId) =>
  $.ajax({
    method: 'POST',
    dataType: 'json',
    url: `/platform-api-v2/bet/pay-out`,
    data: {
      betId,
    },
    ...addHeaders,
  });

export const transferBalance = (sourceUserId, targetUserId, amount, note) =>
  $.ajax({
    method: 'POST',
    dataType: 'json',
    data: {
      sourceUserId,
      targetUserId,
      amount,
      note,
    },
    url: `/platform-api-v2/balance/transfer`,
    ...addHeaders,
  });

export const cashInHand = (targetUserId, amount, note) =>
  $.ajax({
    method: 'POST',
    dataType: 'json',
    data: {
      targetUserId,
      amount,
      note,
    },
    url: `/platform-api-v2/cash/credit`,
    ...addHeaders,
  });

export const agentCashWithdrawal = (targetUserId, amount, note) =>
  $.ajax({
    method: 'POST',
    dataType: 'json',
    data: {
      targetUserId,
      amount,
      note,
    },
    url: `/platform-api-v2/cash/withdraw`,
    ...addHeaders,
  });

export const cashInHandReport = (agentId, dateFrom, dateTo) =>
  $.ajax({
    method: 'POST',
    dataType: 'json',
    data: {
      agentId,
      dateFrom,
      dateTo,
    },
    url: `/platform-api-v2/cash/report`,
    ...addHeaders,
  });

export const cashInHandTransactions = (userId, dateFrom, dateTo) =>
  $.ajax({
    method: 'POST',
    dataType: 'json',
    data: {
      userId,
      dateFrom,
      dateTo,
    },
    url: `/platform-api-v2/cash/transactions`,
    ...addHeaders,
  });

export const agentCashTransfer = (sourceUserId, targetUserId, amount, note) =>
  $.ajax({
    method: 'POST',
    dataType: 'json',
    data: {
      sourceUserId,
      targetUserId,
      amount,
      note,
    },
    url: `/platform-api-v2/cash/transfer`,
    ...addHeaders,
  });

export const searchBettingReport = (createdFrom, createdTo, settledFrom, settledTo, status, page='', pageSize) =>
  $.ajax({
    method: 'GET',
    dataType: 'json',
    url: `/platform-api-v2/report/betting/search?createdFrom=${createdFrom}&createdTo=${createdTo}&settledFrom=${settledFrom}&settledTo=${settledTo}&status=${status}&page=${page}&per-page=${pageSize}`,
    ...addHeaders,
  });

export const generateBettingReport = (createdFrom, createdTo, settledFrom, settledTo, status, page='', pageSize) =>
  $.ajax({
    method: 'GET',
    dataType: 'json',
    url: `/platform-api-v2/report/betting/generate?createdFrom=${createdFrom}&createdTo=${createdTo}&settledFrom=${settledFrom}&settledTo=${settledTo}&status=${status}&page=${page}&per-page=${pageSize}`,
    ...addHeaders,
  });

  export const searchGlobalBetReport = (createdFrom, createdTo, settledFrom, settledTo, status) =>
  $.ajax({
    method: 'GET',
    dataType: 'json',
    url: `/platform-api-v2/report/betting/global-bet-search?createdFrom=${createdFrom}&createdTo=${createdTo}&settledFrom=${settledFrom}&settledTo=${settledTo}&status=${status}`,
    ...addHeaders,
  });

export const generateGlobalBetReport = (createdFrom, createdTo, settledFrom, settledTo, status, userId='') =>
  $.ajax({
    method: 'GET',
    dataType: 'json',
    url: `/platform-api-v2/report/betting/global-bet-generate?createdFrom=${createdFrom}&createdTo=${createdTo}&settledFrom=${settledFrom}&settledTo=${settledTo}&status=${status}&userId=${userId}`,
    ...addHeaders,
  });

export const saveGlobalbetReportAsCsv = (createdFrom, createdTo, settledFrom, settledTo, status, isSearch, userId='') =>
  $.ajax({
    method: 'GET',
    dataType: 'json',
    url: `/platform-api-v2/report/betting/global-bet-${isSearch ? 'search' : 'generate'}-csv?createdFrom=${createdFrom}&createdTo=${createdTo}&settledFrom=${settledFrom}&settledTo=${settledTo}&status=${status}${!isSearch ? '&userId=' + userId : ''}`,
    ...addHeaders,
  });

  export const searchGoldenRaceBetReport = (createdFrom, createdTo, settledFrom, settledTo, status) =>
  $.ajax({
    method: 'GET',
    dataType: 'json',
    url: `/platform-api-v2/report/betting/goldenrace-bet-search?createdFrom=${createdFrom}&createdTo=${createdTo}&settledFrom=${settledFrom}&settledTo=${settledTo}&status=${status}`,
    ...addHeaders,
  });

export const generateGoldenRaceBetReport = (createdFrom, createdTo, settledFrom, settledTo, status) =>
  $.ajax({
    method: 'GET',
    dataType: 'json',
    url: `/platform-api-v2/report/betting/goldenrace-bet-generate?createdFrom=${createdFrom}&createdTo=${createdTo}&settledFrom=${settledFrom}&settledTo=${settledTo}&status=${status}`,
    ...addHeaders,
  });

export const saveGoldenRaceVirtualsReportAsCsv = (createdFrom, createdTo, settledFrom, settledTo, status, isSearch) =>
  $.ajax({
    method: 'GET',
    dataType: 'json',
    url: `/platform-api-v2/report/betting/goldenrace-bet-${isSearch ? 'search' : 'generate'}-csv?createdFrom=${createdFrom}&createdTo=${createdTo}&settledFrom=${settledFrom}&settledTo=${settledTo}&status=${status}`,
    ...addHeaders,
  });

export const getAvailableRegistrationCountries = () =>
  $.ajax({
    method: 'GET',
    dataType: 'json',
    url: `${__APP__.didiApiUrl}/countries`,
  });

export const agentGetAvailablePaymentMethods = () =>
  $.ajax({
    method: 'GET',
    dataType: 'json',
    url: `/platform-api-v2/cps/template/list`,
    ...addHeaders,
  });

export const agentGetCommmissionPlan = (planId) =>
  $.ajax({
    method: 'GET',
    dataType: 'json',
    data: {
      planId
    },
    url: `/platform-api-v2/cps/plan/details`,
    ...addHeaders,
  });

export const agentGetCommmissionReport = (createdFrom, createdTo, sort='', asCsv=1) =>
  $.ajax({
    method: 'GET',
    dataType: 'json',
    url: `/platform-api-v2/cps/report/agent-commission-report?createdFrom=${createdFrom}&createdTo=${createdTo}&sort=${sort}&asCsv=${asCsv}`,
    ...addHeaders,
  });

export const agentCommmissionCreateNewPlan = (name, template) =>
  $.ajax({
    method: 'POST',
    dataType: 'json',
    data: {
      name,
      template
    },
    url: `/platform-api-v2/cps/plan/create`,
    ...addHeaders,
  });

export const agentCommmissionAddRange = (planId, rangeFrom, rangeTo, defaultCoefficient, role='', coefficients='') =>
  $.ajax({
    method: 'POST',
    dataType: 'json',
    data: {
      planId,
      rangeFrom,
      rangeTo,
      defaultCoefficient,
      role,
      coefficients,
    },
    url: `/platform-api-v2/cps/plan/add-range`,
    ...addHeaders,
  });

export const agentCommmissionRemoveRange = (planId, rangeFrom, rangeTo='') =>
  $.ajax({
    method: 'POST',
    dataType: 'json',
    data: {
      planId,
      rangeFrom,
      rangeTo,
    },
    url: `/platform-api-v2/cps/plan/remove-range`,
    ...addHeaders,
  });

export const agentCommissiontGetPlanList = () =>
  $.ajax({
    method: 'GET',
    dataType: 'json',
    url: `/platform-api-v2/cps/plan/list`,
    ...addHeaders,
  });

export const agentCommissiontAssignAgent = (userId, planId) =>
  $.ajax({
    method: 'POST',
    dataType: 'json',
    data: {
      userId,
      planId
    },
    url: `/platform-api-v2/cps/plan/assign`,
    ...addHeaders,
  });

export const agentCommissionUpdatePlan = (userId, planId) =>
  $.ajax({
    method: 'POST',
    dataType: 'json',
    data: {
      userId,
      planId
    },
    url: `/platform-api-v2/cps/plan/upsert`,
    ...addHeaders,
  });

export const agentCommissiontGetAvailableservices = () =>
  $.ajax({
    method: 'GET',
    dataType: 'json',
    url: `/platform-api-v2/cps/plan/available-services`,
    ...addHeaders,
  });

export const agentCommissionPlanCurrent = () =>
  $.ajax({
    method: 'GET',
    dataType: 'json',
    url: `/platform-api-v2/cps/plan/current`,
    ...addHeaders,
  });

export const agentGetUserCommmissionPlan = (userId) =>
  $.ajax({
    method: 'GET',
    dataType: 'json',
    url: `/platform-api-v2/cps/plan/current`,
    data: {
      userId
    },
    ...addHeaders,
  });

export const agentCommissiontUnassignPlanFromAgent = (userId) =>
  $.ajax({
    method: 'POST',
    dataType: 'json',
    data: { userId },
    url: `/platform-api-v2/cps/plan/unassign`,
    ...addHeaders,
  });

export const agentCommissionDailyReports = (dateFrom='', dateTo='', page='', pageSize='', agentId='', groupBy='') =>
  $.ajax({
    method: 'GET',
    dataType: 'json',
    data: { dateFrom, dateTo, page, pageSize, agentId, groupBy },
    url: `/platform-api-v2/cps/report/daily`,
    ...addHeaders,
  });

export const agentGetPeriodsList = () =>
  $.ajax({
      method: 'GET',
      dataType: 'json',
      url: `/platform-api-v2/cps/report/get-report-periods`,
      ...addHeaders,
  });

export const agentCommissionOwnerPeriodReports = (periodDate='', paid='', page='', perPage, asCsv = 1) =>
  $.ajax({
    method: 'GET',
    dataType: 'json',
    data: {
      periodDate,
      paid,
      page,
      'per-page': perPage,
      'asCsv': asCsv
    },
    url: `/platform-api-v2/cps/report/pay-period`,
    ...addHeaders,
  });

export const agentCommissionPeriodReports = (periodDate='', page='', perPage, asCsv = 0, userId='') =>
  $.ajax({
    method: 'GET',
    dataType: 'json',
    data: {
      periodDate,
      page,
      'per-page': perPage,
      'asCsv': asCsv,
      'userId': userId,
    },
    url: `/platform-api-v2/cps/report/period`,
    ...addHeaders,
  });

export const agentPeriodBonusReports = (periodDates='') =>
  $.ajax({
    method: 'GET',
    dataType: 'json',
    url: `/platform-api-v2/cps/report/period-bonus-level?periodDate=${periodDates}`,
    ...addHeaders,
  });

export const agentCommissionPayment = (periodDate, excluded='') =>
  $.ajax({
    method: 'POST',
    dataType: 'json',
    data: {
      periodDate,
      excluded,
    },
    url: `/platform-api-v2/balance/pay-commission`,
    ...addHeaders,
  });

export const getGlobalbet = (live) =>
$.ajax({
  method: 'GET',
  dataType: 'json',
  url: `/platform-api/sportsbook/globalbet${live ? '' : '-demo'}`,
  ...addHeaders,
});

export const generateNewFinancialReport = (dateFrom, dateTo, agentId, pageSize='', page=0, asCsv=1, source='') =>
  $.ajax({
    method: 'GET',
    dataType: 'json',
    url: `/platform-api-v2/report/financial/generate-nested?dateFrom=${dateFrom}&dateTo=${dateTo}&userId=${agentId}&per-page=${pageSize}&page=${page}&asCsv=${asCsv}&source=${source}`,
    ...addHeaders
});

export const financialReportForUser = (dateFrom, dateTo) =>
  $.ajax({
    method: 'GET',
    dataType: 'json',
    url: `/platform-api-v2/report/financial/get-for-user?dateFrom=${dateFrom}&dateTo=${dateTo}`,
    ...addHeaders
});
export const generateNewSbAccountingReport = (createdFrom, createdTo, settledFrom, settledTo, paidFrom, paidTo, status, paidout, userId='', pageSize='', page=0, userRole='', asCsv=1) =>
    $.ajax({
      method: 'GET',
      dataType: 'json',
      url: `/platform-api-v2/report/nested-betting/generate?createdFrom=${createdFrom}&createdTo=${createdTo}&settledFrom=${settledFrom}&settledTo=${settledTo}&paidFrom=${paidFrom}&paidTo=${paidTo}&status=${status}&paid=${paidout}&userId=${userId}&per-page=${pageSize}&page=${page}&userRole=${userRole}&asCsv=${asCsv}`,
      ...addHeaders
    });

  export const generateNewSbTicketsListReport = (createdFrom, createdTo, settledFrom, settledTo, paidFrom, paidTo, status, paidout, userId='', pageSize='', page=0, userRole='', commission=null) =>
    $.ajax({
      method: 'GET',
      dataType: 'json',
      url: `/platform-api-v2/report/nested-betting/search?createdFrom=${createdFrom}&createdTo=${createdTo}&settledFrom=${settledFrom}&settledTo=${settledTo}&paidFrom=${paidFrom}&paidTo=${paidTo}&status=${status}&paid=${paidout}&userId=${userId}&per-page=${pageSize}&page=${page}&userRole=${userRole}`,
      data: {
        commission,
      },
      ...addHeaders
    });

  export const generateNewSbAccountingReportFull = (createdFrom, createdTo, settledFrom, settledTo, status, paidout, userId='') =>
    $.ajax({
      method: 'GET',
      dataType: 'json',
      url: `/platform-api-v2/report/nested-betting/generate-full?createdFrom=${createdFrom}&createdTo=${createdTo}&settledFrom=${settledFrom}&settledTo=${settledTo}&status=${status}&paid=${paidout}&userId=${userId}`,
      ...addHeaders
    });

  export const generateNewSbDailyReport = (createdFrom, createdTo, settledFrom, settledTo, paidFrom, paidTo, status, paidout, userId='', pageSize, page=0, asCsv=1) =>
    $.ajax({
      method: 'GET',
      dataType: 'json',
      url: `/platform-api-v2/report/nested-betting/generate-daily?createdFrom=${createdFrom}&createdTo=${createdTo}&settledFrom=${settledFrom}&settledTo=${settledTo}&paidFrom=${paidFrom}&paidTo=${paidTo}&status=${status}&paid=${paidout}&userId=${userId}&per-page=${pageSize}&page=${page}&asCsv=${asCsv}`,
      ...addHeaders
    });

  export const generateCsvsListFromReports = (pageSize, page=0) =>
    $.ajax({
      method: 'GET',
      dataType: 'json',
      url: `/platform-api-v2/user/file/list?per-page=${pageSize}&page=${page}`,
      ...addHeaders
    });

export const createEntity = (agentId, name, password) =>
  $.ajax({
    method: 'POST',
    dataType: 'json',
    url: `/platform-api-v2/golden-race/create-entity`,
    data: {
      agentId,
      name,
      password,
    },
    ...addHeaders,
  });

export const saveAgentSearchAsCsv = () =>
  $.ajax({
    method: 'GET',
    dataType: 'json',
    url: `/platform-api-v2/hierarchy/get-users-csv`,
    ...addHeaders,
  });

export const searchUserByUsername = (username, perPage = 200) =>
  $.ajax({
    method: 'GET',
    dataType: 'json',
    url: `/platform-api-v2/user/search-users-by-username?username=${username}&per-page=${perPage}`,
    ...addHeaders,
  });
  
export const getAgentOverall = (dateFrom="", dateTo="", settledFrom, settledTo, paidFrom, paidTo) =>
  $.ajax({
    method: 'GET',
    dataType: 'json',
    url: `/platform-api-v2/report/overall/overall?dateFrom=${dateFrom}&dateTo=${dateTo}&settledFrom=${settledFrom}&settledTo=${settledTo}&paidFrom=${paidFrom}&paidTo=${paidTo}`,
    ...addHeaders
  });

export const getAgentMoneyActivity = (dateFrom="", dateTo="", settledFrom, settledTo, paidFrom, paidTo) =>
  $.ajax({
    method: 'GET',
    dataType: 'json',
    url: `/platform-api-v2/report/transaction/money-activity?dateFrom=${dateFrom}&dateTo=${dateTo}&settledFrom=${settledFrom}&settledTo=${settledTo}&paidFrom=${paidFrom}&paidTo=${paidTo}`,
    ...addHeaders
  }); 
  
export const generateOverallActivityReport = (dateFrom, dateTo, settledFrom, settledTo, paidFrom, paidTo, userId='', pageSize='', page=0, asCsv=1) =>
  $.ajax({
    method: 'GET',
    dataType: 'json',
    url: `/platform-api-v2/report/overall/generate?dateFrom=${dateFrom}&dateTo=${dateTo}&settledFrom=${settledFrom}&settledTo=${settledTo}&paidFrom=${paidFrom}&paidTo=${paidTo}&userId=${userId}&per-page=${pageSize}&page=${page}&asCsv=${asCsv}`,
    ...addHeaders
  }); 
  
export const getUserCasinoTransactions = (agentId, dateFrom, dateTo, pageSize='', page=0) =>
  $.ajax({
    method: 'GET',
    dataType: 'json',
    url: `/platform-api-v2/report/casino-transaction/for-user?userId=${agentId}&dateFrom=${dateFrom}&dateTo=${dateTo}&per-page=${pageSize}&page=${page}`,
    ...addHeaders
  });  
